const RouteNames = {
   // USER
   userAddForm: "/user/add-user",
   userList: "/user/user-List",
   userEdit: "/user/update-user/:id",

   // FLEET MASTER
   fleetMasterAddForm: "/fleet-master/add-form",
   fleetMasterList: "/fleet-master/list",
   fleetMasterEdit: "/fleet-master/edit",
   fleetMasterView: "/fleet-master/view/:id",

   // KILOLETER MASTER UNDER FLEET MASTER
   kiloleterMasterAddForm: "/fleet-master/kiloleter-master/add",
   kiloleterMasterView:"/fleet-master/kiloleter-master/list",
   kiloleterMasterEdit:"/fleet-master/kiloleter-master/edit/:id",


   // Tonnage MASTER UNDER FLEET MASTER
   tonnageMasterAddForm: "/fleet-master/tonnage/add",
   tonnageMasterView:"/fleet-master/tonnage/list",
   tonnageMasterEdit:"/fleet-master/tonnage/edit/:id",


   // Vehicle Category MASTER UNDER FLEET MASTER
   vehicleCategoryMasterAddForm: "/fleet-master/vehicle-category/add",
   vehicleCategoryMasterView:"fleet-master/vehicle-category/list",
   vehicleCategoryMasterEdit:"/fleet-master/vehicle-category/edit/:id",

   // Vehicle Category MASTER UNDER FLEET MASTER
   // kiloleterMasterAddForm: "/fleet-master/kiloleter-master/add",
   // kiloleterMasterView:"/fleet-master/kiloleter-master/list",
   // kiloleterMasterEdit:"/fleet-master/kiloleter-master/edit/:id",


   // DRIVER MASTER
   driverMasterAddForm: "/driver-master/add-form",
   driverMasterView: "/driver-master/view",
   driverMasterEdit: "/driver-master/edit/:id",
   fleetAssignment:"/driver-master/fleet-assignment",

   // HELPER MASTER
   helperMasterAddForm: "/helper-master/add-form",
   helperMasterView: "/helper-master/view",
   helperMasterEdit: "/helper-master/edit/:id",

   // CUSTOMER MASTER
   customerMasterAddForm: "/customer-master/add-form",
   customerMasterView: "/customer-master/view",
   customerMasterEdit: "/customer-master/edit/:id",
   customerMasterLaneEdit: "/customer-master/lane/edit/:id",

   // VENDOR MASTER
   vendorMasterAddForm: "/vendor-master/add-form",
   vendorMasterView: "/vendor-master/view",
   vendorMasterEdit: "/vendor-master/edit/:id",

   // LANE MASTER
   LaneMasterAddForm: "/lane-master/add-form",
   laneMasterView: "/lane-master/view",
   laneMasterEdit: "/lane-master/edit/:id",

   // CONTRACTOR MASTER
   ContractorMasterAddForm: "/contractor-master/add-form",
   contractorMasterView: "/contractor-master/view",
   contractorMasterEdit: "/contractor-master/edit/:id",

   // LOCATION MASTER
   LocationMasterAddForm: "/location-master/:formType",
   LocationMasterView: "/location-master/view",
   LocationMasterEdit: "/location-master/:formType/:id",

   // COMPANY MASTER
   CompanyMasterAddForm: "/company-master/add-form",
   CompanyMasterView: "/company-master/view",
   CompanyMasterEdit: "/company-master/edit/:id",

   // ADHOC TRIP
   adhocTripAdd: "/trip/adhoc/add",
   adhocTripView: "/trip/adhoc/view",
   adhocTripEdit: "/trip/adhoc/edit/:id",

   // CONTRACTUAL TRIP
   contaractualTripAdd: "/trip/contractual/add",
   contractualTripView: "/trip/contractual/view",
   contractualTripEdit: "/trip/contractual/edit/:id",

   // ADHOC LANE
   adhocLaneAdd: "/adhoc-lane/add",
   adhocLaneView: "/adhoc-lane/view",
   adhocLaneEdit: "/adhoc-lane/edit/:id",

   // ADHOC VENDOR
   adhocVendorAdd: "/adhoc-vendor/add",
   adhocVendorView: "/adhoc-vendor/view",

   // common pages
   profileView: "/profile",


   // reports 
   loadingReport: "/reports/loading-report",
   vehicleShortageSummaryReport: "/reports/vehicle-shortage-summary-report",
   tripExpensesReport:"/reports/trip-expenses-report",
   performanceReport:"/reports/performance-report",
   monthlyLoadingGraph:"/reports/monthly-loading-graph",
   emiReport: "/reports/emi-report"
};
export default RouteNames;
